import { TalentCreation } from "components/TalentCreationModal";

const TalentCreationPage = () => <TalentCreation />;

export default TalentCreationPage;
